import { render, staticRenderFns } from "./amendTable.vue?vue&type=template&id=755c7a3e&scoped=true&"
import script from "./amendTable.vue?vue&type=script&lang=js&"
export * from "./amendTable.vue?vue&type=script&lang=js&"
import style0 from "./amendTable.vue?vue&type=style&index=0&id=755c7a3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c7a3e",
  null
  
)

export default component.exports